import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

declare var jQuery;
declare var async;
var userID:any;
var systemCode:any;

async.series([
  (callback) => {

    /*get user data*/
    if(localStorage.getItem("userID") != null && localStorage.getItem("userID") != undefined && localStorage.getItem("userID") != "undefined")  
		{
		 userID = localStorage.getItem("userID");
		}
		else
		{
			userID = -1;
		}

    jQuery.ajax({
      url: `${environment.authWebApi.url}/api/UserService/GetMySecurityData/${userID}/${environment.authWebApi.systemCode}`,
      type: 'GET',
      headers: {
        'Accept': 'application/json'// ,
        // 'Authorization': `Bearer ${environment.keyCloak.instance.token}`,
      },
      success: (data) => {
        environment.authWebApi.userData = data;

        return callback();
          },
          error: (jqXHR, textStatus, errorThrown) => {
            return callback(`${jqXHR.status} : ${errorThrown} : ${textStatus}`);
          }
        });
      },
       (callback) => {
             // bootstrap module
             platformBrowserDynamic().bootstrapModule(AppModule).then(() => callback()).catch(callback);
       }

], (error) => {

       // log error to console

       if (error) {
             console.error('Error while starting application =>', error);
       }
       // hide spinner if not hidden after a small time
});


